
import * as directusRuntime$2qk3r92PFp from '/src/node_modules/@nuxt/image/dist/runtime/providers/directus'
import * as ipxRuntime$vU30RJb1Si from '/src/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 100
}

imageOptions.providers = {
  ['directus']: { provider: directusRuntime$2qk3r92PFp, defaults: {"baseURL":"https://epd.zentek.dev/assets/","withoutEnlargement":"true","transforms":[["blur",4],["negate"]]} },
  ['ipx']: { provider: ipxRuntime$vU30RJb1Si, defaults: {} }
}
        